import React, { useContext, useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import Chip from '@mui/material/Chip';
import Switch from '@mui/material/Switch';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Checkbox from '@mui/material/Checkbox';
import './manageClient.css';
import ManageClientTable from '../../components/manageClientTable/manageClientTable'
import { addClient, updateClient, getClientByOrg } from "../../apis/organisationAdminAPI/manageClient";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import Autocomplete from '@mui/material/Autocomplete';
import Cancel from '@mui/icons-material/Cancel';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { getDivisionByOrg } from "../../apis/organisationAdminAPI/manageDivision";
import { UserTypeContext } from "../../AppRoute";
import checkRequisitionExist from "../../apis/checkRequisitionExists/checkRequisitionExists"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import getAllplacementTypeTemplate from "../../apis/placementTypeTemplate/getAllPlacementTemplates"
import getAllCandidateSubmissionField from "../../apis/candidateSubmissionField/getcandidateSubmissionField"
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import Tooltip from '@mui/material/Tooltip';
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const ManageClient = (props) => {
    const location = useLocation();
    const { userType, userRecords } = useContext(UserTypeContext);
    const idContextTest = userType === 'Admin' ? location?.state?.id : userRecords?.id;
    const userRecruitmentpartnerId = userType === 'Admin' ? location?.state?.recruitmentPartnerId : userRecords?.recruitmentpartnerId;
    const userRole = userType === 'Admin' ? location?.state?.userType : userRecords?.role?.roleName;
    const userRecrodData = userType === 'Admin' ? location?.state?.userRecords : userRecords;
    const history = useNavigate();
    const [openDialog, setOpenDialog] = useState(false);
    const [sendMailOn, setSendMailOn] = useState(false);
    const [templateError, setTemplateError] = useState('');

    const [clientData, setClientData] = useState([]);
    const [isDataLoaded, setisDataLoaded] = useState(false);
    const [editedRow, setEditedRow] = useState({});
    const [isActiveFieldDisabled, setIsActiveFieldDisabled] = useState(true)
    const [divisionLink, setDivisionLink] = useState([{ "divisionName": "", "recruitmentLeader": [] }]);
    const [divisionName, setDivisionName] = useState([])
    const [isUserDataUpdating, setIsUserDataUpdating] = useState(false)
    const [exisitingRequisition, setExisitingRequisition] = useState([])
    const [tempRowData, setTempRowData] = useState(null);
    const [placementTypeOption, setPlacementTypeOption] = useState([]);
    const [candidateSubmissionFieldData, setCandidateSubmissionFieldData] = useState([]);

    const [permanentChecked, setPermanentChecked] = useState(false);
    const [contractChecked, setContractChecked] = useState(false);

    const [permanentSelectAll, setPermanentSelectAll] = useState(false);
    const [contractSelectAll, setContractSelectAll] = useState(false);

    const [permanentCheckedItems, setPermanentCheckedItems] = useState({});
    const [contractCheckedItems, setContractCheckedItems] = useState({});
    const [placementTemplates, setPlacementTemplates] = useState({});


    const [originalClientPermanentFields, setOriginalClientPermanentFields] = useState({});
    const [originalClientContractFields, setOriginalClientContractFields] = useState({});

    const [permanentCheckedItemsOption, setPermanentCheckedItemsOption] = useState({});
    const [contractCheckedItemsOption, setContractCheckedItemsOption] = useState({});
    const getAllCandidateSubmissionFieldData = async () => {
        try {
            const response = await getAllCandidateSubmissionField();
            const data = response?.data?.data || [];
            setCandidateSubmissionFieldData(data);

            if (!tempRowData && Object.keys(permanentCheckedItems).length === 0 && Object.keys(contractCheckedItems).length === 0) {
                const permFields = data.filter(d => d.placementTemplateCode === placementTemplates.permanent);
                const contractFields = data.filter(d => d.placementTemplateCode === placementTemplates.contract);

                const permChecked = {};
                permFields.forEach(f => {
                    permChecked[f._id] = false;
                });
                setPermanentCheckedItems(permChecked);

                const contractCheckedObj = {};
                contractFields.forEach(f => {
                    contractCheckedObj[f._id] = false;
                });
                setContractCheckedItems(contractCheckedObj);
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        if (candidateSubmissionFieldData.length > 0 && !tempRowData) {
            const permFields = candidateSubmissionFieldData.filter(field =>
                field.placementTemplateCode.includes(placementTemplates.permanent)
            );
            const contractFields = candidateSubmissionFieldData.filter(field =>
                field.placementTemplateCode.includes(placementTemplates.contract)
            );


            if (Object.keys(permanentCheckedItems).length === 0) {
                const permInit = {};
                permFields.forEach(f => permInit[f._id] = false);
                setPermanentCheckedItems(permInit);
            }

            if (Object.keys(contractCheckedItems).length === 0) {
                const contractInit = {};
                contractFields.forEach(f => contractInit[f._id] = false);
                setContractCheckedItems(contractInit);
            }
        }
    }, [candidateSubmissionFieldData, tempRowData]);

    const handlePlacementTypeCheckboxChange = (event, type) => {
        const checked = event.target.checked;
        if (type.placementTemplateCode === placementTemplates.permanent) {
            setPermanentChecked(checked);
            if (!checked) {

                setPermanentCheckedItems(prev => {
                    const updated = {};
                    Object.keys(prev).forEach(id => {
                        updated[id] = false;
                    });
                    return updated;
                });
                setPermanentSelectAll(false);
            } else {

                const fieldsToRestore = Object.keys(originalClientPermanentFields).length > 0
                    ? originalClientPermanentFields
                    : permanentCheckedItems;

                setPermanentCheckedItems(fieldsToRestore);

                const permFields = candidateSubmissionFieldData.filter(f =>
                    f.placementTemplateCode.includes(placementTemplates.permanent) && f.isActive
                );
                const allSelected = permFields.every(f => fieldsToRestore[f._id]);
                setPermanentSelectAll(allSelected);
            }
        } else if (type.placementTemplateCode === placementTemplates.contract) {
            setContractChecked(checked);
            if (!checked) {

                setContractCheckedItems(prev => {
                    const updated = {};
                    Object.keys(prev).forEach(id => {
                        updated[id] = false;
                    });
                    return updated;
                });
                setContractSelectAll(false);
            } else {
                const fieldsToRestore = Object.keys(originalClientContractFields).length > 0
                    ? originalClientContractFields
                    : contractCheckedItems;

                setContractCheckedItems(fieldsToRestore);

                const contractFields = candidateSubmissionFieldData.filter(f =>
                    f.placementTemplateCode.includes(placementTemplates.contract) && f.isActive
                );
                const allSelected = contractFields.every(f => fieldsToRestore[f._id]);
                setContractSelectAll(allSelected);
            }
        }
    };

    const handlePermanentSelectAllChange = (e) => {
        const checked = e.target.checked;
        setPermanentSelectAll(checked);

        setPermanentCheckedItems(prev => {
            const updated = { ...prev };

            const permFields = candidateSubmissionFieldData.filter(f =>
                f.placementTemplateCode.includes(placementTemplates.permanent) && f.isActive
            );


            permFields.forEach(field => {
                updated[field._id] = checked;
            });

            return updated;
        });
    };

    const handleContractSelectAllChange = (e) => {
        const checked = e.target.checked;
        setContractSelectAll(checked);

        setContractCheckedItems(prev => {
            const updated = { ...prev };

            const contractFields = candidateSubmissionFieldData.filter(f =>
                f.placementTemplateCode.includes(placementTemplates.contract) && f.isActive
            );


            contractFields.forEach(field => {
                updated[field._id] = checked;
            });

            return updated;
        });
    };

    const handlePermanentItemChange = (id) => (e) => {
        const checked = e.target.checked;
        setPermanentCheckedItems(prev => {
            const updated = { ...prev, [id]: checked };


            const permFields = candidateSubmissionFieldData.filter(f =>
                f.placementTemplateCode.includes(placementTemplates.permanent) && f.isActive
            );
            const allChecked = permFields.length > 0 &&
                permFields.every(f => updated[f._id]);
            setPermanentSelectAll(allChecked);

            return updated;
        });
    };

    const handleContractItemChange = (id) => (e) => {
        const checked = e.target.checked;
        setContractCheckedItems(prev => {
            const updated = { ...prev, [id]: checked };


            const contractFields = candidateSubmissionFieldData.filter(f =>
                f.placementTemplateCode.includes(placementTemplates.contract) && f.isActive
            );
            const allChecked = contractFields.length > 0 &&
                contractFields.every(f => updated[f._id]);
            setContractSelectAll(allChecked);

            return updated;
        });
    };


    const handleOpenDialog = () => {
        setOpenDialog(true);
    };
    const [ClientInfo, setClientInfo] = useState({
        name: "",
        address: "",
        active: { name: "True", value: true },
        clientId: ""
    })

    const activeDropDown = [
        { name: "True", value: true },
        { name: "False", value: false },
    ];

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEditedRow({});
        setClientInfo({
            name: "",
            address: "",
            active: { name: "True", value: true }
        })
        setIsActiveFieldDisabled(true);
        setDivisionLink([{
            "divisionName": "",
            "recruitmentLeader": []
        }])
        setExisitingRequisition([])
        setContractSelectAll(false)
        setPermanentSelectAll(false)
        setContractChecked(false)
        setPermanentChecked(false)
        setContractCheckedItems({})
        setPermanentCheckedItems({})
        setSendMailOn(false)
        setTempRowData(null)
        setOriginalClientPermanentFields({})
        setOriginalClientContractFields({})
        setPermanentCheckedItemsOption({})
        setContractCheckedItemsOption({})
        setTemplateError('')
    };

    const hasPlacementTemplateData = (placementTemplateCode) => {

        const fieldsForTemplate = candidateSubmissionFieldData.filter(
            field => field.placementTemplateCode.includes(placementTemplateCode) && field.isActive
        );

        return fieldsForTemplate.length > 0;
    };

    const handleSubmit = async () => {

        if (templateError) {
            // NotificationManager.error(templateError, "Error", 2500);
            return;
        }

        let isValid = true;
        divisionLink.forEach((item) => {
            if (item.divisionName === "" || item.recruitmentLeader.length === 0) {
                isValid = false;
                NotificationManager.error("Please fill in all the fields", "Error", 10000);
                return
            }
        })
        if (ClientInfo.name === "" || ClientInfo.active === null) {
            isValid = false;
            NotificationManager.error("Please fill in all the fields", "Error", 10000);
            return
        }


        if (sendMailOn && isValid) {
            if (permanentChecked) {
                const hasSelectedPermanentFields = Object.values(permanentCheckedItems).some(checked => checked);
                if (!hasSelectedPermanentFields) {
                    isValid = false;
                    NotificationManager.error("Please select at least one field for Permanent placement type", "Error", 10000);
                    return;
                }
            }

            if (contractChecked) {
                const hasSelectedContractFields = Object.values(contractCheckedItems).some(checked => checked);
                if (!hasSelectedContractFields) {
                    isValid = false;
                    NotificationManager.error("Please select at least one field for Contract placement type", "Error", 10000);
                    return;
                }
            }

            if (!permanentChecked && !contractChecked) {
                isValid = false;
                NotificationManager.error("Please select at least one placement type when email notification is enabled", "Error", 10000);
                return;
            }
        }

        if (isValid) {
            let divisionData = [];
            for (let i = 0; i < divisionLink.length; i++) {
                let item = divisionLink[i];
                let divisionItem = {
                    divisionId: item?.divisionName?._id,
                };
                if (item?.recruitmentLeader) {
                    divisionItem.recruitmentLeaderDetails = [];
                    for (let j = 0; j < item.recruitmentLeader.length; j++) {
                        let leader = item.recruitmentLeader[j];
                        divisionItem.recruitmentLeaderDetails.push({
                            id: leader.id,
                            email: leader.email
                        });
                    }
                }

                divisionData.push(divisionItem);
            }

            let payload = {
                "clientName": ClientInfo.name,
                "address": ClientInfo.address,
                "isActive": ClientInfo.active.value,
                "recruitmentpartnerId": userRecruitmentpartnerId,
                "divisionDetails": divisionData,
                isEmailRequired: sendMailOn,
                configs: []
            }

            setIsUserDataUpdating(true)
            if (Object.keys(editedRow).length > 0) {
                try {

                    if (!ClientInfo.active.value) {
                        payload.isEmailRequired = editedRow.isEmailRequired;

                        const configs = editedRow.clientSubmissionConfigs || [];
                        payload.configs = Array.isArray(configs[0]) ? configs[0] : configs;
                    }

                    else if (sendMailOn) {
                        let placementPayload = [];


                        const templatesToProcess = [];
                        const existingTemplates = editedRow.clientSubmissionConfigs
                            ?.flat()
                            ?.map(config => config.placementTemplateCode) || [];
                        const currentTemplates = [];
                        if (permanentChecked) currentTemplates.push(placementTemplates.permanent);
                        if (contractChecked) currentTemplates.push(placementTemplates.contract);
                        const allTemplates = [...new Set([...existingTemplates, ...currentTemplates])];
                        templatesToProcess.push(...allTemplates);

                        const buildPayload = (placementCode, checkedItems, checked) => {
                            const selectedPlacementType = placementTypeOption.find(
                                t => t.placementTemplateCode === placementCode || t.code === placementCode
                            );

                            const existingConfig = editedRow.clientSubmissionConfigs
                                ?.flat()
                                ?.find(cfg => cfg.placementTemplateCode === placementCode);


                            const existingSubmissionCodes = existingConfig?.submissionField?.map(f => f.submissionCode) || [];

                            const allFields = candidateSubmissionFieldData
                                .filter(f => f.placementTemplateCode.includes(placementCode));


                            const submissionFields = allFields
                                .filter(f => {
                                    const wasExisting = existingSubmissionCodes.includes(f.submissionCode);
                                    const isCurrentlyChecked = checkedItems[f._id];


                                    return wasExisting || isCurrentlyChecked;
                                })
                                .map(f => {
                                    let isFieldActive = true;

                                    if (sendMailOn && checked) {

                                        isFieldActive = checkedItems[f._id] || false;
                                    } else if (Object.keys(editedRow).length > 0) {

                                        const existingField = existingConfig?.submissionField?.find(
                                            field => field.submissionCode === f.submissionCode
                                        );
                                        if (existingField) {
                                            isFieldActive = existingField.isFieldActive;
                                        }
                                    }

                                    return {
                                        submissionCode: f.submissionCode,
                                        isFieldActive: isFieldActive
                                    };
                                });


                            if (selectedPlacementType && submissionFields.length > 0) {
                                const configEntry = {
                                    placementTemplateCode: selectedPlacementType.placementTemplateCode,
                                    isActive: checked,
                                    submissionField: submissionFields
                                };


                                if (existingConfig && existingConfig._id) {
                                    configEntry._id = existingConfig._id;
                                }

                                placementPayload.push(configEntry);
                            }
                        };


                        templatesToProcess.forEach(templateCode => {
                            const isChecked = templateCode === placementTemplates.permanent ? permanentChecked : contractChecked;
                            const checkedItems = templateCode === placementTemplates.permanent ? permanentCheckedItems : contractCheckedItems;
                            buildPayload(templateCode, checkedItems, isChecked);
                        });

                        payload.configs = placementPayload;
                    }

                    setIsUserDataUpdating(true);

                    const response = await updateClient(editedRow._id, payload);
                    if (response.status === 200) {
                        NotificationManager.success("Client details updated successfully", "Success", 10000);
                        handleCloseDialog();
                        allClientsData();
                    }
                    else if (response.status === 202) {
                        const errorMessage = response.data.message;
                        NotificationManager.error(errorMessage, "Error", 10000);
                    }
                } catch (error) {
                    if (error.response?.status === 400 && error.response.data?.errorCode === 400) {
                        const errorMessage = error.response.data.errMessage;
                        NotificationManager.error(errorMessage, "Error", 10000);
                    }
                } finally {
                    setIsUserDataUpdating(false);
                }
            }


            else {
                try {
                    let configs = [];


                    if (sendMailOn) {
                        if (permanentChecked) {
                            const selectedPlacementType = placementTypeOption.find(
                                t => t.placementTemplateCode === placementTemplates.permanent
                            );

                            const permFields = candidateSubmissionFieldData.filter(
                                f => f.placementTemplateCode.includes(placementTemplates.permanent)
                            );

                            const selectedFields = permFields
                                .filter(f => permanentCheckedItems[f._id])
                                .map(f => ({
                                    submissionCode: f.submissionCode,
                                    isFieldActive: f.isActive
                                }));

                            configs.push({
                                placementTemplateCode: selectedPlacementType.placementTemplateCode,
                                isActive: true,
                                submissionField: selectedFields
                            });
                        }

                        if (contractChecked) {
                            const selectedPlacementType = placementTypeOption.find(
                                t => t.placementTemplateCode === placementTemplates.contract
                            );

                            const contractFields = candidateSubmissionFieldData.filter(
                                f => f.placementTemplateCode.includes(placementTemplates.contract)
                            );

                            const selectedFields = contractFields
                                .filter(f => contractCheckedItems[f._id])
                                .map(f => ({
                                    submissionCode: f.submissionCode,
                                    isFieldActive: f.isActive
                                }));

                            configs.push({
                                placementTemplateCode: selectedPlacementType.placementTemplateCode,
                                isActive: true,
                                submissionField: selectedFields
                            });
                        }
                    }

                    payload.configs = configs;

                    const response = await addClient(payload);
                    if (response.status === 200) {
                        NotificationManager.success("Client has been added successfully", "Success", 10000);

                        handleCloseDialog();
                        allClientsData();
                    } else if (response.status === 202) {
                        const errorMessage = response.data.message;
                        NotificationManager.error(errorMessage, "Error", 10000);
                    }
                } catch (error) {
                    if (error.response && error.response.status === 400 && error.response.data.errorCode === 400) {
                        const errorMessage = error.response.data.errMessage;
                        NotificationManager.error(errorMessage, "Error", 10000);
                    } else {

                        NotificationManager.error("An unexpected error occurred", "Error", 10000);
                    }
                }
            }

            setIsUserDataUpdating(false);
        }
    };



    const allClientsData = async () => {
        setClientData([]);
        setisDataLoaded(false)
        let payload = {
            recruitmentPartnerId: userRecruitmentpartnerId
        }
        try {
            setisDataLoaded(false)
            let response = await getClientByOrg(payload);

            if (response.status === 200) {
                let arr = []
                let data = response.data.data

                for (let i = 0; i < data.length; i++) {
                    let emails = [];
                    if (data[i].divisionDetails) {
                        for (let j = 0; j < data[i].divisionDetails.length; j++) {
                            let division = data[i].divisionDetails[j];
                            if (division.recruitmentLeaderDetails) {
                                for (let k = 0; k < division.recruitmentLeaderDetails.length; k++) {
                                    emails.push(division.recruitmentLeaderDetails[k].email);
                                }
                            }
                        }
                    }
                    data[i].recruiterLeaderEmails = emails.join(', ');
                    let divisionNames = "";
                    if (data[i].assignedDivisions) {
                        for (let j = 0; j < data[i].assignedDivisions.length; j++) {
                            let division = data[i].assignedDivisions[j][0];
                            divisionNames += division?.divisionName
                            if (j < data[i].assignedDivisions.length - 1) {
                                divisionNames += ", ";
                            }
                        }
                    }
                    data[i].selectedDivisionNames = divisionNames !== "undefined" ? divisionNames : "N/A";
                    arr.push(data[i]);
                }

                setClientData(arr);
            }
            setisDataLoaded(true)

        } catch (error) {
            setisDataLoaded(true)
            setClientData([]);
            NotificationManager.error("Something Went Wrong!", "error", 10000)
        }
    };

    const getAllDivision = async () => {
        try {
            let payload = {
                recruitmentpartnerId: userRecruitmentpartnerId,
                isActive: true
            }
            let response = await getDivisionByOrg(payload);
            setDivisionName(response.data.data)
        } catch (error) {
            console.log(error)
        }
    }

    const getPlacementTemplates = async () => {
        try {
            const response = await getAllplacementTypeTemplate();
            const templates = response?.data?.data || [];
            setPlacementTypeOption(templates);


            const templateMapping = {};
            templates.forEach(template => {
                if (template.name.toLowerCase().includes('permanent')) {
                    templateMapping.permanent = template.placementTemplateCode;
                } else if (template.name.toLowerCase().includes('contract')) {
                    templateMapping.contract = template.placementTemplateCode;
                }
            });
            setPlacementTemplates(templateMapping);

            return templateMapping;
        } catch (error) {
            console.error("Error fetching placement templates:", error);
            return {};
        }
    };


    const handleNameChange = (e) => {
        if (e.target.value) {
            setClientInfo({ ...ClientInfo, name: e.target.value })
        } else {
            setClientInfo({ ...ClientInfo, name: "" })
        }
    }
    const handleAddressChange = (e) => {
        setClientInfo({ ...ClientInfo, address: e.target.value })
    }
    const handleActiveChange = async (e, value) => {
        if (value) {
            setClientInfo({ ...ClientInfo, active: value })
        } else {
            setClientInfo({ ...ClientInfo, active: null })
        }


        if (Object.keys(editedRow).length > 0 && value && !value.value) {

            if (editedRow.clientSubmissionConfigs && editedRow.clientSubmissionConfigs.length > 0) {

                let configs;
                if (Array.isArray(editedRow.clientSubmissionConfigs[0])) {

                    configs = editedRow.clientSubmissionConfigs[0];
                } else {

                    configs = editedRow.clientSubmissionConfigs;
                }

                const permFields = candidateSubmissionFieldData.filter(field =>
                    field.placementTemplateCode.includes(placementTemplates.permanent)
                );
                const contractFields = candidateSubmissionFieldData.filter(field =>
                    field.placementTemplateCode.includes(placementTemplates.contract)
                );

                const permInit = {};
                const contractInit = {};

                permFields.forEach(f => permInit[f._id] = false);
                contractFields.forEach(f => contractInit[f._id] = false);


                const permanentConfig = configs.find(config => config.placementTemplateCode === placementTemplates.permanent);
                if (permanentConfig) {
                    setPermanentChecked(permanentConfig.isActive);

                    permanentConfig.submissionField.forEach(configField => {
                        const matchingField = permFields.find(f => f.submissionCode === configField.submissionCode);
                        if (matchingField) {
                            permInit[matchingField._id] = configField.isFieldActive;
                        }
                    });

                    const enabledPermFields = permFields.filter(f => {
                        const configField = permanentConfig.submissionField.find(
                            sf => sf.submissionCode === f.submissionCode
                        );
                        return configField && configField.isFieldActive;
                    });
                    const allPermanentSelected = enabledPermFields.length > 0 &&
                        enabledPermFields.every(field => permInit[field._id]);
                    setPermanentSelectAll(allPermanentSelected);
                } else {
                    setPermanentChecked(false);
                    setPermanentSelectAll(false);
                }


                const contractConfig = configs.find(config => config.placementTemplateCode === placementTemplates.contract);
                if (contractConfig) {
                    setContractChecked(contractConfig.isActive);

                    contractConfig.submissionField.forEach(configField => {
                        const matchingField = contractFields.find(f => f.submissionCode === configField.submissionCode);
                        if (matchingField) {
                            contractInit[matchingField._id] = configField.isFieldActive;
                        }
                    });

                    const enabledContractFields = contractFields.filter(f => {
                        const configField = contractConfig.submissionField.find(
                            sf => sf.submissionCode === f.submissionCode
                        );
                        return configField && configField.isFieldActive;
                    });
                    const allContractSelected = enabledContractFields.length > 0 &&
                        enabledContractFields.every(field => contractInit[field._id]);
                    setContractSelectAll(allContractSelected);
                } else {
                    setContractChecked(false);
                    setContractSelectAll(false);
                }

                setPermanentCheckedItems(permInit);
                setContractCheckedItems(contractInit);
            } else {
                setPermanentChecked(false);
                setContractChecked(false);
                setPermanentSelectAll(false);
                setContractSelectAll(false);
                setPermanentCheckedItems({});
                setContractCheckedItems({});
            }
        }
    }
    const handelEditOpenDialog = () => {
        setOpenDialog(true);
    }


    const divisionChangeHandler = (value, index) => {
        const originalData = [...divisionLink];
        const changingData = originalData[index];
        if (value) {
            changingData["divisionName"] = value;
            changingData["recruitmentLeader"] = [];
        } else {
            changingData["divisionName"] = "";
            changingData["recruitmentLeader"] = [];
        }
        originalData[index] = changingData;
        setDivisionLink(originalData || []);
    }

    const recruitmentLeaderChangeHandler = (value, index) => {

        const originalData = [...divisionLink];
        const changingData = originalData[index];
        if (value) {
            changingData["recruitmentLeader"] = value;
        } else {
            changingData["recruitmentLeader"] = [];
        }
        originalData[index] = changingData;
        setDivisionLink(originalData || []);

    }

    const deleteRecruitmentLeaderHandler = async (option, index) => {
        try {
            if (Object.keys(editedRow).length > 0) {
                let payload = {
                    recruitmentLeaderId: option.id,
                    recruitmentPartnerId: userRecruitmentpartnerId,
                    clientId: ClientInfo.clientId,
                    validation: "Client"
                }
                const dataRes = await checkRequisitionExist(payload);
                if (dataRes?.status === 200 && dataRes?.data?.data.length > 0) {
                    NotificationManager.error(
                        `${dataRes?.data?.message}`,
                        "error",
                        10000);
                } else if (dataRes.status === 400 && dataRes.errorCode === 400) {
                    const errorMessage = dataRes.data.message;
                    NotificationManager.error(errorMessage, "Error", 10000);

                }
                else {
                    let oldArr = [...divisionLink];
                    let recruitmentLeaders = [...oldArr[index].recruitmentLeader];
                    const newRecruitmentLeader = recruitmentLeaders.filter((item) => item.id !== option.id);
                    oldArr[index] = {
                        ...oldArr[index],
                        recruitmentLeader: newRecruitmentLeader
                    };
                    setDivisionLink(oldArr);
                }
            } else {
                let oldArr = [...divisionLink];
                let recruitmentLeaders = [...oldArr[index].recruitmentLeader];
                const newRecruitmentLeader = recruitmentLeaders.filter((item) => item.id !== option.id);
                oldArr[index] = {
                    ...oldArr[index],
                    recruitmentLeader: newRecruitmentLeader
                };
                setDivisionLink(oldArr);
            }

        } catch (error) {
            NotificationManager.error("Something Went Wrong!", "error", 10000)
        }

    }

    const handleEdit = async (rowData) => {
        setClientInfo({
            ...ClientInfo,
            name: rowData.clientName,
            address: rowData.address,
            active: {
                name: rowData.isActive ? "True" : "False",
                value: rowData.isActive
            },
            clientId: rowData._id
        });

        const transformedDivisionLink = [];
        for (let index = 0; index < rowData.divisionDetails.length; index++) {
            let detail = rowData.divisionDetails[index];
            let filteredDivisionName = divisionName.filter((item) => item._id === detail?.divisionId)[0];

            transformedDivisionLink.push({
                divisionName: filteredDivisionName,
                recruitmentLeader: detail?.recruitmentLeaderDetails
            });
        }

        setDivisionLink(transformedDivisionLink);
        setEditedRow(rowData);


        setTempRowData(rowData);


        setSendMailOn(rowData.isEmailRequired || false);


        if (!rowData.isEmailRequired) {
            setPermanentChecked(false);
            setContractChecked(false);
            setPermanentSelectAll(false);
            setContractSelectAll(false);
        }

        try {
            let payload = {
                recruitmentPartnerId: userRecruitmentpartnerId,
                clientId: rowData?._id,
                validation: "Client"
            }
            const data = await checkRequisitionExist(payload);
            setExisitingRequisition(data?.data?.data)
            const requisitionExists = data?.data?.data?.length;
            if (requisitionExists > 0 && rowData) {
                setIsActiveFieldDisabled(true)
            }
            else {
                setIsActiveFieldDisabled(false)
            }
        } catch (error) {
            NotificationManager.error("Something Went Wrong!", "error", 10000)
        }

        handelEditOpenDialog();
    };
    useEffect(() => {
        if (tempRowData && candidateSubmissionFieldData.length > 0 && sendMailOn && Object.keys(placementTemplates).length > 0) {
            const rowData = tempRowData;

            if (rowData.clientSubmissionConfigs && rowData.clientSubmissionConfigs.length > 0) {

                const configs = Array.isArray(rowData.clientSubmissionConfigs[0])
                    ? rowData.clientSubmissionConfigs[0]
                    : rowData.clientSubmissionConfigs;


                const permFields = candidateSubmissionFieldData.filter(field =>
                    field.placementTemplateCode.includes(placementTemplates.permanent)
                );
                const contractFields = candidateSubmissionFieldData.filter(field =>
                    field.placementTemplateCode.includes(placementTemplates.contract)
                );


                const permInit = {};
                const contractInit = {};
                const clientOriginalPermFields = {};
                const clientOriginalContractFields = {};
                const newPermCheckedOption = {};
                const newContractCheckedOption = {};

                permFields.forEach(f => permInit[f._id] = false);
                contractFields.forEach(f => contractInit[f._id] = false);


                const permanentConfig = configs.find(config => config.placementTemplateCode === placementTemplates.permanent);
                if (permanentConfig) {

                    if (permanentConfig.isActive) {
                        setPermanentChecked(true);
                    } else {
                        setPermanentChecked(false);
                    }


                    permanentConfig.submissionField.forEach(configField => {
                        const matchingField = permFields.find(f => f.submissionCode === configField.submissionCode);
                        if (matchingField) {
                            newPermCheckedOption[matchingField._id] = configField.isFieldActive;
                        }
                    });


                    permFields.forEach(field => {
                        const matchingSubmissionField = permanentConfig.submissionField.find(
                            sf => sf.submissionCode === field.submissionCode
                        );
                        if (matchingSubmissionField) {
                            permInit[field._id] = matchingSubmissionField.isFieldActive;
                            clientOriginalPermFields[field._id] = matchingSubmissionField.isFieldActive;
                        }
                    });


                    const enabledPermFields = permFields.filter(f => f.isActive);
                    const allPermanentSelected = enabledPermFields.length > 0 && enabledPermFields.every(field => permInit[field._id]);
                    setPermanentSelectAll(allPermanentSelected);
                } else {
                    setPermanentChecked(false);
                    setPermanentSelectAll(false);
                }

                setPermanentCheckedItems(permInit);


                const contractConfig = configs.find(config => config.placementTemplateCode === placementTemplates.contract);
                if (contractConfig) {

                    if (contractConfig.isActive) {
                        setContractChecked(true);
                    } else {
                        setContractChecked(false);
                    }


                    contractConfig.submissionField.forEach(configField => {
                        const matchingField = contractFields.find(f => f.submissionCode === configField.submissionCode);
                        if (matchingField) {
                            newContractCheckedOption[matchingField._id] = configField.isFieldActive;
                        }
                    });


                    contractFields.forEach(field => {
                        const matchingSubmissionField = contractConfig.submissionField.find(
                            sf => sf.submissionCode === field.submissionCode
                        );
                        if (matchingSubmissionField) {
                            contractInit[field._id] = matchingSubmissionField.isFieldActive;
                            clientOriginalContractFields[field._id] = matchingSubmissionField.isFieldActive;
                        }
                    });


                    const enabledContractFields = contractFields.filter(f => f.isActive);
                    const allContractSelected = enabledContractFields.length > 0 && enabledContractFields.every(field => contractInit[field._id]);
                    setContractSelectAll(allContractSelected);
                } else {
                    setContractChecked(false);
                    setContractSelectAll(false);
                }

                setContractCheckedItems(contractInit);


                setOriginalClientPermanentFields(clientOriginalPermFields);
                setOriginalClientContractFields(clientOriginalContractFields);
                setPermanentCheckedItemsOption(newPermCheckedOption);
                setContractCheckedItemsOption(newContractCheckedOption);
            } else {

                setPermanentChecked(false);
                setContractChecked(false);
                setPermanentSelectAll(false);
                setContractSelectAll(false);


                const permFields = candidateSubmissionFieldData.filter(field =>
                    field.placementTemplateCode.includes(placementTemplates.permanent)
                );
                const contractFields = candidateSubmissionFieldData.filter(field =>
                    field.placementTemplateCode.includes(placementTemplates.contract)
                );

                const permInit = {};
                permFields.forEach(f => permInit[f._id] = false);
                setPermanentCheckedItems(permInit);

                const contractInit = {};
                contractFields.forEach(f => contractInit[f._id] = false);
                setContractCheckedItems(contractInit);
            }


            setTempRowData(null);
        }
    }, [tempRowData, candidateSubmissionFieldData, sendMailOn, placementTemplates]);

    const goToDashboard = () => {
        history("/dashboard",
            {
                state: {
                    userType: userType,
                    recruitmentPartnerId: userRecruitmentpartnerId,
                    id: idContextTest,
                    userRecords: userRecrodData,
                    roleName: userRole
                }
            });
    }



    const addDiVisionLink = () => {
        const row = {
            "divisionName": "",
            "recruitmentLeader": []
        };
        if (divisionLink) {
            setDivisionLink([...divisionLink, row])
        }

    }

    const extraDivisionLinkClose = (index, item) => {
        if (checkDisbale_division(item) || checkDisbale_RecruiterLeader(item)) {
            NotificationManager.error("Unable to make changes as a requisition already exists for this client and division.", "Error", 10000);
        } else {
            let originalData = [...divisionLink];
            originalData.splice(index, 1);
            setDivisionLink(originalData || []);
        }

    }


    const checkDisbale_division = (item) => {
        let data = exisitingRequisition?.filter((element) => element.divisionId === item.divisionName?._id)
        if (data?.length > 0) {
            return true
        }
        else {
            return false;
        }
    }
    const checkDisbale_RecruiterLeader = (item) => {
        let data = exisitingRequisition?.filter((element) => element.assignedTo === item.recruitmentLeader?.id)
        if (data?.length > 0) {
            return true
        }
        else {
            return false;
        }
    }

    const filteredRecruitmentLeaders = (item) => {
        let data = divisionName.filter((val) => val._id === item.divisionName?._id)
        if (data.length > 0) {
            data = data[0].teamDetails
            data = data.map((item) => item.recruiterLeaderDetails)
        }
        let filteredOptions = data.filter(itemVal => {
            let isAlreadySelected = false;
            item.recruitmentLeader.forEach(leader => {
                if (leader.id === itemVal.id) {
                    isAlreadySelected = true;
                }
            })
            return !isAlreadySelected;
        })
        return filteredOptions
    }

    const getFilteredDivision = () => {
        let arr = [];

        divisionName.forEach((item) => {
            let data = divisionLink.filter((element) => element.divisionName?._id === item._id)
            if (data.length === 0) {
                arr.push(item)
            }
        })
        return arr
    }

    useEffect(() => {
        if (userRecruitmentpartnerId && (
            userType === "Organization Admin" ||
            userType === "MIS Operator" ||
            (userType === "Admin" && userRole === "Organization Admin") ||
            (userType === "Admin" && userRole === "MIS Operator")
        )) {
            getAllDivision();
            allClientsData();
        }
    }, [userType])

    useEffect(() => {
        if (sendMailOn) {
            getPlacementTemplates();
            getAllCandidateSubmissionFieldData()
        }
    }, [sendMailOn]);

    // Template validation useEffect
    useEffect(() => {
        if (sendMailOn && candidateSubmissionFieldData.length > 0) {
            const hasAvailableTemplates = placementTypeOption.some(type => {
                const templateCode = type.placementTemplateCode || type.code;
                return hasPlacementTemplateData(templateCode);
            });

            if (!hasAvailableTemplates) {
                setTemplateError('Please select any template. No placement template configurations are available for this client.');
            } else if (!permanentChecked && !contractChecked) {
                setTemplateError('Please select at least one placement type (Permanent or Contract).');
            } else {
                setTemplateError('');
            }
        } else {
            setTemplateError('');
        }
    }, [sendMailOn, placementTypeOption, permanentChecked, contractChecked, candidateSubmissionFieldData]);





    return (
        <>
            {(userType === "Organization Admin" || userType === "MIS Operator" || (userType === 'Admin' && userRole === 'Organization Admin') || (userType === 'Admin' && userRole === 'MIS Operator')) ?
                <>
                    <div className="manageClient_container">
                        <div className="manageClient_header_container">
                            <div className="manageClient_header_left">
                                <div className="manageClient_goBackButton" onClick={(e) => goToDashboard(e)}>
                                    <Tooltip title="Go Back to Dashboard" placement="bottom">
                                        <ArrowBackIcon sx={{ fontSize: 20 }} />
                                    </Tooltip>
                                </div>
                                <div className="manageClient_title">Manage Clients</div>
                            </div>
                            {userType === "Admin" ? "" :
                                <div className="manageClient_header_right">
                                    <Button className="manageClient_addButton"
                                        onClick={handleOpenDialog}
                                        startIcon={<PersonAddAltIcon alt="Add Client" style={{ width: "22px", height: "22px" }} />}
                                    >
                                        Add Client
                                    </Button>
                                </div>
                            }
                        </div>
                        <ManageClientTable clientData={clientData} isDataLoaded={isDataLoaded} onEdit={handleEdit} userType={userType} />
                    </div>

                </>
                :
                <UnauthorizedAccess />
            }

            <Dialog
                open={openDialog}
                className="manage-client-modal"
                onClose={handleCloseDialog}
                aria-labelledby="dialog-title"
                maxWidth="sm"
                fullWidth
            >
                <div className="client_dialog_modal" >
                    <div className='client-dialog-TitleContainer'>
                        {<PersonAddAltIcon alt="Add Client" style={{ width: "22px", height: "22px" }} />}
                        <span className="dialog-title-text">{Object.keys(editedRow).length > 0 ? 'Edit Client' : 'Add Client'}</span>
                    </div>
                </div>
                <DialogContent className="client-dialog-content">
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="field-title-client-dialog">Client Name*</Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Enter Client Name"
                                value={ClientInfo.name}
                                onChange={handleNameChange}
                                className="input-field-client-dialog"
                            />
                        </Grid>


                        {divisionLink.map((item, i) => (
                            <Grid container spacing={2} size={{ xs: 12 }} key={`clientsArr_${i}`}>
                                <Grid size={divisionLink.length > 1 ? 5 : 6}>
                                    <Typography className="field-title-client-dialog">
                                        Division Name*
                                    </Typography>
                                    <Autocomplete
                                        id="multiple-limit-tags"
                                        options={getFilteredDivision()}
                                        getOptionLabel={(option) =>
                                            option.divisionName ? option.divisionName : ""
                                        }
                                        closeIcon={null}
                                        value={item.divisionName}
                                        disabled={checkDisbale_division(item)}
                                        onChange={(e, val) => divisionChangeHandler(val, i)}
                                        filterSelectedOptions
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                required={true}
                                                placeholder="Division"
                                            />
                                        }
                                    />
                                </Grid>
                                <Grid size={{ xs: 6 }}>
                                    <Typography className="field-title-client-dialog">
                                        Recruitment Leader*
                                    </Typography>

                                    <FormControl fullWidth variant="outlined">
                                        <Autocomplete
                                            id="multiple-limit-tags"
                                            options={item.divisionName === "" ? [] : filteredRecruitmentLeaders(item)}
                                            getOptionLabel={(option) =>
                                                option.email ? option.email : ""
                                            }
                                            autoHighlight
                                            filterSelectedOptions
                                            multiple
                                            disabled={checkDisbale_RecruiterLeader(item)}
                                            closeIcon={null}
                                            value={item.recruitmentLeader}
                                            onChange={(e, val) => recruitmentLeaderChangeHandler(val, i)}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    required={true}
                                                    placeholder="Recruitment Leader"
                                                    onKeyDown={(event) => {
                                                        if (event.key === 'Backspace') {
                                                            event.stopPropagation();
                                                        }
                                                    }}
                                                />
                                            }
                                            renderTags={(value, getTagProps) => {
                                                return (
                                                    value.map((option, index) => (
                                                        <Chip
                                                            label={option.email}
                                                            {...getTagProps({ index })}
                                                            onDelete={() => deleteRecruitmentLeaderHandler(option, i)}
                                                        />
                                                    ))
                                                );
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid size={{ xs: 1 }}>
                                    {divisionLink.length > 1 ?
                                        <Cancel className="cancelIcon_leadersArr" onClick={(e) => extraDivisionLinkClose(i, item)} />
                                        : ""}
                                </Grid>
                            </Grid>
                        ))}
                        <Grid size={{ xs: 12 }} className="addButtonGrid_addLeadersArr">
                            <AddCircleIcon
                                color="primary"
                                onClick={(e) => addDiVisionLink(e)}
                                className="addIcon_leadersArr"
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Typography className="field-title-client-dialog">Address</Typography>
                            <TextField
                                multiline
                                fullWidth
                                variant="outlined"
                                minRows={3}
                                placeholder="Enter Address"
                                value={ClientInfo.address}
                                onChange={handleAddressChange}
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="field-title-client-dialog">Is Active*</Typography>
                            <Autocomplete
                                id="combo-box-demo"
                                value={ClientInfo.active}
                                options={activeDropDown}
                                disabled={editedRow ? isActiveFieldDisabled : false}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Active"
                                    />
                                )}
                                onChange={handleActiveChange}
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Typography className="field-title-client-field">Requires Email Submission</Typography>
                            <div className="searchtoggleContainer">
                                <Switch
                                    checked={sendMailOn}
                                    onChange={() => setSendMailOn((prev) => !prev)}
                                    disabled={Object.keys(editedRow).length > 0 && !ClientInfo.active.value}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ "aria-label": "primary checkbox" }}
                                />
                                <span className="booleanText">{sendMailOn ? "YES" : "NO"}</span>
                            </div>
                        </Grid>

                        {sendMailOn && (
                            <Grid size={{ xs: 12 }}>
                                {templateError && (
                                    <div className="spoc-template-container">
                                        {templateError}
                                    </div>
                                )}
                                <Typography className="field-title-client-dialog_template">
                                    * Please select your preferred method of template
                                </Typography>

                                <Grid size={{ xs: 12 }} className="manageclient_accordion_container">
                                    {placementTypeOption.map((type, index) => {
                                        const isPermanent = type.placementTemplateCode === placementTemplates.permanent;
                                        const checked = isPermanent ? permanentChecked : contractChecked;
                                        const selectAll = isPermanent ? permanentSelectAll : contractSelectAll;
                                        const checkedItems = isPermanent ? permanentCheckedItems : contractCheckedItems;

                                        const filteredFields = candidateSubmissionFieldData.filter(field =>
                                            field.placementTemplateCode.includes(
                                                type.placementTemplateCode || type.code
                                            )
                                        );

                                        return (
                                            <Accordion key={type._id} expanded={checked}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls={`panel${index}-content`}
                                                    id={`panel${index}-header`}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <div className="manageclient_accordion">
                                                        <Checkbox
                                                            checked={checked}
                                                            onChange={(e) => handlePlacementTypeCheckboxChange(e, type)}
                                                            disabled={Object.keys(editedRow).length > 0 && !ClientInfo.active.value}
                                                            color="primary"
                                                            inputProps={{ "aria-label": `${type.name} checkbox` }}
                                                        />
                                                        <Typography className="manageclient_accordion_header">
                                                            {type.name}
                                                        </Typography>
                                                    </div>
                                                </AccordionSummary>

                                                <AccordionDetails>
                                                    <div className="client_accordion_details_container">
                                                        <input
                                                            type="checkbox"
                                                            id={`${type.name.toLowerCase()}-select-all`}
                                                            checked={selectAll}
                                                            disabled={Object.keys(editedRow).length > 0 && !ClientInfo.active.value}
                                                            onChange={
                                                                isPermanent
                                                                    ? handlePermanentSelectAllChange
                                                                    : handleContractSelectAllChange
                                                            }
                                                            style={{ transform: "scale(1.5)", cursor: "pointer" }}
                                                        />
                                                        <label
                                                            htmlFor={`${type.name.toLowerCase()}-select-all`}
                                                            className="client_accordion_details_select-all"
                                                        >
                                                            Select All
                                                        </label>
                                                    </div>

                                                    <div className="client_options_accordion_container">
                                                        {filteredFields.map((item) => (
                                                            <div key={item._id} className="client_option_accordion_container">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`${type.name.toLowerCase()}-check-${item._id}`}
                                                                    checked={checkedItems[item._id] || false}
                                                                    disabled={Object.keys(editedRow).length > 0 && !ClientInfo.active.value}
                                                                    onChange={
                                                                        isPermanent
                                                                            ? handlePermanentItemChange(item._id)
                                                                            : handleContractItemChange(item._id)
                                                                    }
                                                                    style={{ transform: "scale(1.5)", cursor: "pointer" }}
                                                                />
                                                                <label
                                                                    htmlFor={`${type.name.toLowerCase()}-check-${item._id}`}
                                                                    className="client_option_accordion_label"
                                                                >
                                                                    {item.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </AccordionDetails>
                                            </Accordion>
                                        );
                                    })}
                                </Grid>
                            </Grid>
                        )}





                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-actionbutton-client">
                    <button onClick={handleCloseDialog} className="cancel-button-client">
                        Cancel
                    </button>
                    <button
                        className={isUserDataUpdating ? 'updateButton-client_disabled' : 'updateButton-client'}
                        onClick={handleSubmit}
                        disabled={isUserDataUpdating}
                    >
                        <span>Save</span>
                        {isUserDataUpdating ? (<CircularProgress className="circularProgress_updateButton" />) : null}
                    </button>
                </DialogActions>
            </Dialog >

        </>
    )
}

export default ManageClient;

